<template>
	<div class="content">
		<section
			id="hero"
			class="container-expanded container-no-pad cols"
		>
			<div class="col col-6">
				<div class="col-inner col-center col-center-vert">
					<img
						src="@/images/podcast-hero.webp"
						alt="Real Schools of Thought Podcast"
					/>
				</div>
			</div>
			<div class="col col-6">
				<div class="col-inner col-center col-center-vert">
					<h1>
						<span class="title-color-mustard">Real</span> Conversations.<br />
						<span class="title-color-honey">Real</span> Change.<br />
						<span class="title-color-orange">Real</span> Schools.
					</h1>
				</div>
			</div>
		</section>

		<section
			id="listen-now"
			class="container band"
		>
			<div class="cols">
				<div class="col col-12 text-center">
					<h5 class="title">Listen Now</h5>
					<div class="links">
						<a
							href="https://overcast.fm/itunes1831912899/real-schools-of-thought-with-adam-voigt"
							target="_blank"
							title="Listen on Overcast"
						>
							<img
								src="@/images/podcast/overcast.png"
								alt="Overcast"
							/>
						</a>
						<a
							href="https://open.spotify.com/show/4raHHffiLaAHlBjfXigwNO"
							target="_blank"
							title="Listen on Spotify"
						>
							<img
								src="@/images/podcast/spotify.png"
								alt="Spotify"
							/>
						</a>
						<a
							href="https://podcasts.apple.com/us/podcast/real-schools-of-thought-with-adam-voigt/id1831912899"
							target="_blank"
							title="Listen on Apple Podcasts"
						>
							<img
								src="@/images/podcast/apple.png"
								alt="Apple Podcasts"
							/>
						</a>
						<a
							href="https://pocketcasts.com/podcasts/dd723190-59b6-013e-ac0c-0affd8d03709"
							target="_blank"
							title="Listen on Pocket Casts"
						>
							<img
								src="@/images/podcast/pocketcasts.png"
								alt="Pocket Casts"
							/>
						</a>
					</div>
				</div>
			</div>
		</section>

		<section
			id="intro"
			class="container-expanded container cols band"
		>
			<div class="col col-2" />
			<div class="col col-center">
				<h3 class="title text-center">About Real Schools of Thought</h3>
				<p>Hosted by Adam Voigt, Real Schools of Thought is a bold, reflective podcast for principals, aspiring school leaders and educators who are ready to rethink the way schools work.</p>
				<p>Through raw, story-rich conversations with real changemakers in education, we go beyond policies and programs to explore the personal mindset shifts, leadership moments and cultural decisions that truly shape our schools.</p>
				<p>It’s not about being perfect – it’s about being real.</p>
			</div>
			<div class="col col-2" />
		</section>

		<section
			id="podcasts"
			class="container-expanded container-no-pad band"
		>
			<div class="container">
				<template
					v-for="(season, index) in allPodcasts"
					:key="index"
				>
					<h2 class="title">{{ season.name }}</h2>
					<div class="podcasts">
						<div
							:id="`podcast-season-${podcast.season}-episode-${podcast.episode}`"
							v-for="podcast in season.podcasts"
							:key="`podcast-season-${podcast.season}-episode-${podcast.episode}`"
							class="podcast"
						>
							<div class="details">
								<h6>
									Episode {{ podcast.episode }} | <span v-if="podcast.with">{{ podcast.with }} and </span>Adam Voigt
								</h6>
								<h3>{{ podcast.title }}</h3>
								<p>{{ podcast.shortDescription }}</p>
							</div>
							<div class="links">
								<h6>Listen Now</h6>
								<div class="links-top">
									<a
										:href="podcast.linkSpotify"
										target="_blank"
									>
										<img
											src="@/images/podcast/spotify.png"
											alt="Listen on Spotify"
										/>
									</a>
									<a
										:href="podcast.linkApple"
										target="_blank"
									>
										<img
											src="@/images/podcast/apple.png"
											alt="Listen on Apple Podcasts"
										/>
									</a>
								</div>
								<div class="links-bottom">
									<a
										:href="podcast.linkOvercast"
										target="_blank"
									>
										<img
											src="@/images/podcast/overcast.png"
											alt="Listen on Overcast"
										/>
									</a>
									<a
										:href="podcast.linkPocketCasts"
										target="_blank"
									>
										<img
											src="@/images/podcast/pocketcasts.png"
											alt="Listen on Pocket Casts"
										/>
									</a>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</section>

		<section class="alternatings cols container-expanded container-no-pad">
			<div class="col col-6">
				<div class="col-inner">
					<h3>About Adam</h3>
					<p><strong>Adam Voigt, Founder & CEO of Real Schools</strong></p>
					<p>Adam is a former school principal who’s spent over 20 years leading real change in real schools. Through his work at Real Schools, he’s helped thousands of educators shift culture, lift engagement, and build schools where both students and staff thrive.</p>
					<p>He’s not a theorist – he’s been in the trenches. He started this podcast to share the real, raw, and reflective stories behind school leadership and culture.</p>
					<p>He will go beyond strategy and theory to unpack the moments, mindset shifts, and decisions that truly shape our schools, and inspire you to create the changes in our educational landscape that our kids – and our educators – deserve.</p>
				</div>
			</div>
			<div
				id="adam"
				class="col col-6"
			></div>
		</section>

		<section class="alternatings cols container-expanded container-no-pad reverse-on-mobile">
			<div
				id="group"
				class="col col-6"
			></div>

			<div class="col col-6">
				<div class="col-inner">
					<h3>Pitch a Guest or Drop Us a Line</h3>
					<p>Adam is always looking to feature educators, leaders, thinkers and doers who are making waves in schools and beyond.</p>
					<p>If you’d like to:</p>
					<ul>
						<li>Nominate a guest (yourself included!)</li>
						<li>Suggest a topic</li>
						<li>Ask a question</li>
						<li>Collaborate or partner with us</li>
					</ul>
					<p>...we’d love to hear from you.</p>
					<p>Email us at <a href="mailto: info@realschools.com.au">info@realschools.com.au</a> and let’s make it happen!</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import heroImage from '@/images/background-geometric-blue.webp';
import adamImage from '@/images/adam.jpg';
import groupImage from '@/images/group.webp';
import { wrapBackgroundImageUrlToCss } from '@/helpers';

export default defineComponent({
	data() {
		return {
			allPodcasts: [
				{
					name: 'Season 4',
					podcasts: [
						{
							title: 'Clarity Is Kind',
							with: 'Justine McNaught-Conroy',
							shortDescription: 'Leading 1,400 students across two campuses could easily become an exercise in control. Instead, Wanneroo Secondary College Principal Justine McNaught-Conroy has built a culture where clear structures, high expectations and genuine trust give people the confidence to do their best work. In this conversation with Adam, Justine shares what intentional visibility really looks like, why authentic relationships need to survive the hard conversations, and how building a place where people feel supported has transformed staff retention.',
							longDescription: 'Leading 1,400 students across two campuses could easily become an exercise in control. Instead, Wanneroo Secondary College Principal Justine McNaught-Conroy has built a culture where clear structures, high expectations and genuine trust give people the confidence to do their best work. In this conversation with Adam, Justine shares what intentional visibility really looks like, why authentic relationships need to survive the hard conversations, and how building a place where people feel supported has transformed staff retention.',
							mins: 35,
							season: 4,
							episode: 6,
							linkSpotify: 'https://open.spotify.com/episode/0lGdvQD95vEgzkmsICRwQy',
							linkApple: 'https://podcasts.apple.com/us/podcast/clarity-is-kind/id1831912899?i=1000791958305',
							linkOvercast: 'https://overcast.fm/+BQ5Lc8rIjo',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/clarity-is-kind/9bcd70a1-d5b5-4630-9310-917aae5ec5fc',
						},
						{
							title: 'The Guy Who Cared',
							with: 'Dean Finlay',
							shortDescription: 'For almost two decades at Ocean Road Primary School, Dean Finlay has built his leadership around one deceptively simple idea: people need to know you care. In this conversation with Adam, Dean shares how small, consistent acts have built trust with students, staff and families – and how restorative practice has helped turn those relationships into a culture that is shared and lived across the school. It’s a conversation about leadership, legacy and why, after a career spent learning what makes good schools work, Dean keeps coming back to where he started: relationships.',
							longDescription: 'For almost two decades at Ocean Road Primary School, Dean Finlay has built his leadership around one deceptively simple idea: people need to know you care. In this conversation with Adam, Dean shares how small, consistent acts have built trust with students, staff and families – and how restorative practice has helped turn those relationships into a culture that is shared and lived across the school. It’s a conversation about leadership, legacy and why, after a career spent learning what makes good schools work, Dean keeps coming back to where he started: relationships.',
							mins: 33,
							season: 4,
							episode: 5,
							linkSpotify: 'https://open.spotify.com/episode/3jXP7z0lleWq3P8K3uWUPi',
							linkApple: 'https://podcasts.apple.com/us/podcast/the-guy-who-cared-a-conversation-with-adam/id1831912899?i=1000790877162',
							linkOvercast: 'https://overcast.fm/+BQ5LdqJy0s',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/the-guy-who-cared-a-conversation-with-adam-voigt-and-dean-finlay/b334c1b7-7235-4bbe-9891-97e4004c0b23',
						},
						{
							title: 'What Special Schools Can Teach Every School',
							with: 'Peter Bush',
							shortDescription: 'Peter Bush, Principal of Kalianna School, joins Adam to challenge some long-held assumptions about special education and what young people with disabilities can achieve. From high expectations and authentic learning to the power of language, predictable routines and repairing relationships, Peter shares lessons that reach well beyond the special school setting. It’s a conversation about looking past what kids can’t do – and creating schools that help every young person see what they can.',
							longDescription: 'Peter Bush, Principal of Kalianna School, joins Adam to challenge some long-held assumptions about special education and what young people with disabilities can achieve. From high expectations and authentic learning to the power of language, predictable routines and repairing relationships, Peter shares lessons that reach well beyond the special school setting. It’s a conversation about looking past what kids can’t do – and creating schools that help every young person see what they can.',
							mins: 37,
							season: 4,
							episode: 4,
							linkSpotify: 'https://open.spotify.com/episode/6tFkP7tVu1VPrHWMPGf6SO',
							linkApple: 'https://podcasts.apple.com/us/podcast/what-special-schools-can-teach-every-school/id1831912899?i=1000789690670',
							linkOvercast: 'https://overcast.fm/+BQ5LdiZMVk',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/what-special-schools-can-teach-every-school/8ae358d7-18f6-4ed6-8ea5-2043ea44e3f7',
						},
						{
							title: 'Teaching Is Still Great Work',
							with: 'Vicki Minton',
							shortDescription: 'What happens when a school stops operating as individual classrooms, teams and campuses – and starts working as one? Baden-Powell College Principal Vicki Minton joins Adam Voigt to talk about building collective ownership of culture, creating genuine collaboration between teachers and giving students the skills to manage relationships and resolve conflict. And amid all the noise about workload, burnout and behaviour, Vicki makes a compelling case for something we probably don’t say loudly enough: teaching is brilliant, important and deeply rewarding work.',
							longDescription: 'What happens when a school stops operating as individual classrooms, teams and campuses – and starts working as one? Baden-Powell College Principal Vicki Minton joins Adam Voigt to talk about building collective ownership of culture, creating genuine collaboration between teachers and giving students the skills to manage relationships and resolve conflict. And amid all the noise about workload, burnout and behaviour, Vicki makes a compelling case for something we probably don’t say loudly enough: teaching is brilliant, important and deeply rewarding work.',
							mins: 35,
							season: 4,
							episode: 3,
							linkSpotify: 'https://open.spotify.com/episode/5zxm5SZYgnO5pwj0Wg89ss',
							linkApple: 'https://podcasts.apple.com/us/podcast/teaching-is-still-great-work-a-conversation-with/id1831912899?i=1000788242321',
							linkOvercast: 'https://overcast.fm/+BQ5Lejz5vE',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/teaching-is-still-great-work-a-conversation-with-adam-voigt-and-vicky-minton/dbcb7c67-903c-44ce-8eac-f1c092538619',
						},
						{
							title: "Don't Smile Till Easter (And Other Things Jacqui Unlearned)",
							with: 'Jacqui Fimister',
							shortDescription: 'Adam sits down with Kananook Primary teacher Jacqui Fimister to reflect on 13 years of working together, and the practices she’s unlearned along the way. From peg charts and “Don’t smile till Easter,” to restorative language, reflective practice and putting relationships first, Jacqui shares what she had to unlearn — and what she does differently now.',
							longDescription: 'Adam sits down with Kananook Primary teacher Jacqui Fimister to reflect on 13 years of working together, and the practices she’s unlearned along the way. From peg charts and “Don’t smile till Easter,” to restorative language, reflective practice and putting relationships first, Jacqui shares what she had to unlearn — and what she does differently now.',
							mins: 39,
							season: 4,
							episode: 2,
							linkSpotify: 'https://open.spotify.com/episode/6lkxPoiPOWrSzqel96soMt?si=BtN1i5mZThimO4Y9FLFXRA',
							linkApple: 'https://podcasts.apple.com/us/podcast/classroom-teacher-ditching-the-peg-chart-building/id1831912899?i=1000787007818',
							linkOvercast: 'https://overcast.fm/+BQ5LfcDoK0',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/classroom-teacher-ditching-the-peg-chart-building-a-restorative-classroom-with-jackie-fimister/7c7418b0-7ef2-46e7-a3be-9bab79f983b2',
						},
						{
							title: 'Leadership and Trust: A New Era in Schools',
							with: 'Liz Foster',
							shortDescription: 'In this engaging conversation, Liz Foster and Adam discuss the profound impact of great teachers, the importance of building trust in educational leadership, and the need for a culture of courage and experimentation in schools. They explore the role of professional associations in supporting educators and the significance of collaboration and connection in fostering a positive school environment. Liz emphasizes the need to elevate the teaching profession and encourages school leaders to take actionable steps towards creating a more trusting and innovative educational landscape.',
							longDescription: 'In this engaging conversation, Liz Foster and Adam discuss the profound impact of great teachers, the importance of building trust in educational leadership, and the need for a culture of courage and experimentation in schools. They explore the role of professional associations in supporting educators and the significance of collaboration and connection in fostering a positive school environment. Liz emphasizes the need to elevate the teaching profession and encourages school leaders to take actionable steps towards creating a more trusting and innovative educational landscape.',
							mins: 37,
							season: 4,
							episode: 1,
							linkSpotify: 'https://open.spotify.com/episode/4wjbpdoFSlCKwtRoORE9kV',
							linkApple: 'https://podcasts.apple.com/us/podcast/leadership-and-trust-a-new-era-in-schools-with-liz-foster/id1831912899?i=1000785441865',
							linkOvercast: 'https://overcast.fm/+BQ5LeJXwxk',
							linkPocketCasts: '',
						},
					],
				},
				{
					name: 'Season 3',
					podcasts: [
						{
							title: 'The Koonawarra Way: Changing School from the Inside Out',
							with: 'Amanda Kowalczyk',
							shortDescription: 'Amanda Kowalczyk transformed Koonawarra Public School from low expectations and disengagement to a thriving, connected community. In this episode, she shares how culture change inside a complex school reshaped student experience and influenced system policy.',
							longDescription: 'Amanda Kowalczyk transformed Koonawarra Public School from low expectations and disengagement to a thriving, connected community. In this episode, she shares how culture change inside a complex school reshaped student experience and influenced system policy.',
							mins: 35,
							season: 3,
							episode: 6,
							linkSpotify: 'https://open.spotify.com/episode/4uVGDlJCW8voMijIc01dnI',
							linkApple: 'https://podcasts.apple.com/us/podcast/the-koonawarra-way-changing-school-from-the-inside-out/id1831912899?i=1000772785715',
							linkOvercast: 'https://overcast.fm/+BQ5LdHtI30',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/the-koonawarra-way-changing-school-from-the-inside-out/42c3c73e-9559-444b-9f9d-a763f43857ad',
						},
						{
							title: 'Modelling Curiosity in Education: A Conversation with Tracey Ezard',
							with: 'Tracey Ezard',
							shortDescription: 'Tracey Ezard, respected expert on school culture and author of Ferocious Warmth, joins Adam for an honest conversation about leadership, struggling and thriving cultures, and the gap many schools sit in, drawing on decades of shared experience.',
							longDescription: 'Tracey Ezard, respected expert on school culture and author of Ferocious Warmth, joins Adam for an honest conversation about leadership, struggling and thriving cultures, and the gap many schools sit in, drawing on decades of shared experience.',
							mins: 38,
							season: 3,
							episode: 5,
							linkSpotify: 'https://open.spotify.com/episode/5py3tanVSohxE4tcSGI9eQ',
							linkApple: 'https://podcasts.apple.com/us/podcast/modelling-curiosity-in-education-a-conversation/id1831912899?i=1000771664177',
							linkOvercast: 'https://overcast.fm/+BQ5LcOYVtU',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/modelling-curiosity-in-education-a-conversation-with-tracey-ezard/bfc3408a-3263-49e5-acb6-7868ffe384c0',
						},
						{
							title: 'Teacher, Leader and AFL Legend Simon Madden: Lessons on Resilience and Culture',
							with: 'Simon Madden',
							shortDescription: 'Adam Voigt sits down with AFL legend and Hall of Famer Simon Madden for a conversation that covers a lot more than football. Simon is also a former teacher and Assistant Principal, and in this episode he brings those two worlds together in the best way.',
							longDescription: 'Adam Voigt sits down with AFL legend and Hall of Famer Simon Madden for a conversation that covers a lot more than football. Simon is also a former teacher and Assistant Principal, and in this episode he brings those two worlds together in the best way. From the teachers who shaped him as a kid to the high-performance habits he developed across decades in elite sport, Simon shares a refreshingly grounded take on what it means to lead, learn, and build a culture worth showing up for.',
							mins: 37,
							season: 3,
							episode: 4,
							linkSpotify: 'https://open.spotify.com/episode/3p5bLsXovtAzI3ZowKSZhd',
							linkApple: 'https://podcasts.apple.com/us/podcast/teacher-leader-and-afl-legend-simon-madden-lessons-on/id1831912899?i=1000770555889',
							linkOvercast: 'https://overcast.fm/+BQ5LfYmZ9o',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/teacher-leader-and-afl-legend-simon-madden-lessons-on-resilience-and-culture/2ca0abfc-3bd4-46ec-b591-64260f7e1c56',
						},
						{
							title: 'Reclaiming the Profession: A Conversation with Lisa Newland',
							with: 'Lisa Newland',
							shortDescription: 'Lisa Newland, incoming CEO of the Australian Council for Educational Leaders, discusses compliance culture, teacher autonomy, and the pressures of public data. She reflects on how playing it safe impacts innovation and joy, offering a direct, honest perspective on modern education.',
							longDescription: 'Lisa Newland, incoming CEO of the Australian Council for Educational Leaders, discusses compliance culture, teacher autonomy, and the pressures of public data. She reflects on how playing it safe impacts innovation and joy, offering a direct, honest perspective on modern education.',
							mins: 35,
							season: 3,
							episode: 3,
							linkSpotify: 'https://open.spotify.com/episode/4nbZgFa1PH4SAeOtaWAhKZ?si=84dd88d1f0f546f0',
							linkApple: 'https://podcasts.apple.com/us/podcast/reclaiming-the-profession-a-conversation/id1831912899?i=1000769465470',
							linkOvercast: 'https://overcast.fm/+BQ5LeMqRac',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/reclaiming-the-profession-a-conversation-with-lisa-newland/5cf4fdb9-41c1-469e-9304-d402e47b75a8',
						},
						{
							title: 'The Importance of Joy in Schools: A Conversation with Lee Crockett',
							with: 'Lee Crockett',
							shortDescription: 'In this engaging conversation, Lee Crockett explores agency in education, the role of leadership in shaping culture, and the importance of trust and joy. He highlights professional wellness, challenges myths about excellence, and emphasises authentic, present leadership.',
							longDescription: 'In this engaging conversation, Lee Crockett explores agency in education, the role of leadership in shaping culture, and the importance of trust and joy. He highlights professional wellness, challenges myths about excellence, and emphasises authentic, present leadership.',
							mins: 42,
							season: 3,
							episode: 2,
							linkSpotify: 'https://open.spotify.com/episode/0evStqUM6a7V6IWtqKSaP3?si=3bc5a95d15114a8a',
							linkApple: 'https://podcasts.apple.com/us/podcast/the-importance-of-joy-in-schools-a/id1831912899?i=1000768379297',
							linkOvercast: 'https://overcast.fm/+BQ5LcgPvXc',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/the-importance-of-joy-in-schools-a-conversation-with-lee-crockett/e2cdb722-0a3b-4be4-90ea-e2c2026c662f',
						},
						{
							title: 'What Surviving Loss Teaches You About Kids: A courageous conversation',
							with: 'Anita Olegario',
							shortDescription: 'Anita Olegario, a teacher at Berrima Public School, shares a deeply honest conversation about losing her son Brodie to suicide, and how that experience shapes her teaching, giving her purpose and changing how she understands and supports struggling students. Content note: This episode includes a personal account of youth suicide and grief. Please take care of yourself as you listen.',
							longDescription: 'Anita Olegario, a teacher at Berrima Public School, shares a deeply honest conversation about losing her son Brodie to suicide, and how that experience shapes her teaching, giving her purpose and changing how she understands and supports struggling students. Content note: This episode includes a personal account of youth suicide and grief. Please take care of yourself as you listen.',
							mins: 35,
							season: 3,
							episode: 1,
							linkSpotify: 'https://open.spotify.com/episode/78cnhhQBuDanNwhHLFSTNt?si=a4c613179a69438e',
							linkApple: 'https://podcasts.apple.com/us/podcast/what-surviving-loss-teaches-you-about-kids-a/id1831912899?i=1000767464858',
							linkOvercast: 'https://overcast.fm/+BQ5Lf60twU',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/what-surviving-loss-teaches-you-about-kids-a-courageous-conversation-with-anita-olegario/cb159a2d-b402-444c-b7f8-2c03735d2002',
						},
					],
				},
				{
					name: 'Season 2 - Summer Series',
					podcasts: [
						{
							title: 'The Hopeful Horizon of Education in Australia',
							with: 'Professor John Hattie',
							shortDescription: 'Professor John Hattie explains why great teaching matters more than ever, how culture and instruction intersect, and what teachers must hold onto – and let go of – as AI reshapes classrooms.',
							longDescription: 'Professor John Hattie explains why great teaching matters more than ever, how culture and instruction intersect, and what teachers must hold onto – and let go of – as AI reshapes classrooms.',
							mins: 39,
							season: 2,
							episode: 1,
							linkSpotify: 'https://open.spotify.com/episode/50qtUa5FYqcl5Z6hSXmrjD?si=61d047f3db9a438e',
							linkApple: 'https://podcasts.apple.com/us/podcast/professor-john-hattie-the-hopeful-horizon-of/id1831912899?i=1000740459096',
							linkOvercast: 'https://overcast.fm/+BQ5LeY5umk',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/professor-john-hattie-the-hopeful-horizon-of-education-in-australia/120b3d5e-fc89-4284-ba83-9f71ec84fabd',
						},
						{
							title: "Teaching Through Heart and Purpose: Nick Dodd's Story",
							with: 'Nick Dodd',
							shortDescription: 'In this episode, Nick Dodd reveals the leadership moves that transformed Clarence High School – boosting engagement, attendance and achievement while halving suspensions in just one year.',
							longDescription: 'In this episode, Nick Dodd reveals the leadership moves that transformed Clarence High School – boosting engagement, attendance and achievement while halving suspensions in just one year.',
							mins: 44,
							season: 2,
							episode: 2,
							linkSpotify: 'https://open.spotify.com/episode/5U5huR0Yvj58a94m9owdgo?si=756495122d8b4f20',
							linkApple: 'https://podcasts.apple.com/us/podcast/teaching-through-heart-and-purpose-nick-dodds-story/id1831912899?i=1000741567874',
							linkOvercast: 'https://overcast.fm/+BQ5LeW3flE',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/teaching-through-heart-and-purpose-nick-dodds-story/9200aeb5-c51f-4525-9747-35556ff17036',
						},
						{
							title: "How'd we end up at Real Schools?",
							with: 'Adam Voigt',
							shortDescription: 'Adam Voigt shares the story of how his journey began in Frankston, was shaped by working with Aboriginal communities in the Northern Territory, and led to principalship and the creation of Real Schools – and why supporting schools at scale became his hardest, but most important, decision.',
							longDescription: 'Adam Voigt shares the story of how his journey began in Frankston, was shaped by working with Aboriginal communities in the Northern Territory, and led to principalship and the creation of Real Schools – and why supporting schools at scale became his hardest, but most important, decision.',
							mins: 26,
							season: 2,
							episode: 3,
							linkSpotify: 'https://open.spotify.com/episode/11ohh3wNlRy6Dm3zQuzosk',
							linkApple: 'https://podcasts.apple.com/us/podcast/howd-we-end-up-at-real-schools/id1831912899?i=1000745087490',
							linkOvercast: 'https://overcast.fm/+BQ5LeJFXp0',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/howd-we-end-up-at-real-schools/3c0a030d-1adc-42ef-ad95-2edf0d97454d',
						},
						{
							title: "The Power of a Smile. Matt Kenny's Secret to School Success",
							with: 'Matt Kenny',
							shortDescription: 'In a grounded conversation, Matt Kenny and Adam Voigt explore why relationships, unity in leadership and understanding behaviour are the quiet forces behind successful, sustainable schools.',
							longDescription: 'In a grounded conversation, Matt Kenny and Adam Voigt explore why relationships, unity in leadership and understanding behaviour are the quiet forces behind successful, sustainable schools.',
							mins: 34,
							season: 2,
							episode: 4,
							linkSpotify: 'https://open.spotify.com/episode/1qvyvnSgz7u1Ig6DPa2IkS',
							linkApple: 'https://podcasts.apple.com/us/podcast/the-power-of-a-smile-matt-kennys-secret-to-school-success/id1831912899?i=1000745932207',
							linkOvercast: 'https://overcast.fm/+BQ5Lf8n8eY',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/the-power-of-a-smile-matt-kennys-secret-to-school-success/fde9b9a6-1a31-4e9c-a4a5-e3ddf4f0455c',
						},
						{
							title: "If We Funded Schools Properly… Here's What Would Actually Change",
							with: 'Tina King',
							shortDescription: 'Tina King, Victorian President of the Australian Principals Federation, makes the case for what would actually change in schools if funding matched reality — and why leadership and collegiality matter more than ever for complex classrooms.',
							longDescription: 'Tina King, Victorian President of the Australian Principals Federation, makes the case for what would actually change in schools if funding matched reality — and why leadership and collegiality matter more than ever for complex classrooms.',
							mins: 36,
							season: 2,
							episode: 5,
							linkSpotify: 'https://open.spotify.com/episode/71aSomIPRr1MP6PhKk5id2?si=b00cf7de280044b7',
							linkApple: 'https://podcasts.apple.com/us/podcast/if-we-funded-schools-properly-heres-what-would-actually/id1831912899?i=1000746899293',
							linkOvercast: 'https://overcast.fm/+BQ5LeeEJ_4',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/if-we-funded-schools-properlyheres-what-would-actually-change-with-tina-king/e5a0d229-70ac-4ed0-a7c5-4f7e11908f1f',
						},
						{
							title: 'The Story and Influence of Aboriginal & Torres Strait Islander People on Real Schools',
							with: '',
							shortDescription: 'In this solo episode Adam opens up the real story behind RP2.0 and the deep influence Aboriginal and Torres Strait Islander peoples have had on his teaching, leadership and restorative approach. He traces the three knowledge bases that shape the model affect theory, social and organisational psychology and the wisdom gifted to him through First Nations educators, elders and families.',
							longDescription: 'In this solo episode Adam opens up the real story behind RP2.0 and the deep influence Aboriginal and Torres Strait Islander peoples have had on his teaching, leadership and restorative approach. He traces the three knowledge bases that shape the model affect theory, social and organisational psychology and the wisdom gifted to him through First Nations educators, elders and families.',
							mins: 29,
							season: 2,
							episode: 6,
							linkSpotify: 'https://open.spotify.com/episode/16l1CSrwFJrijIW7dA4Ymy',
							linkApple: 'https://podcasts.apple.com/us/podcast/the-story-and-influence-of-aboriginal-torres/id1831912899?i=1000747902664',
							linkOvercast: 'https://overcast.fm/+BQ5LekOU_c',
							linkPocketCasts: 'https://pocketcasts.com/podcast/real-schools-of-thought-with-adam-voigt/dd723190-59b6-013e-ac0c-0affd8d03709/the-story-and-influence-of-aboriginal-torres-strait-islander-people-on-real-schools/929d0142-d99a-40d9-8cda-4fe0f5e7dd01',
						},
					],
				},
				{
					name: 'Season 1',
					podcasts: [
						{
							title: "Empowering Change: Martine Gill's Journey of Leadership and Community",
							with: 'Martine Gill',
							shortDescription: 'Join us as Martine Gill shares her transformative journey, blending leadership and personal growth to empower communities and redefine education.',
							longDescription: 'Join us in this inspiring episode as we sit down with Martine Gill, the principal of Clover Hill State School. Martine shares her journey from aspiring teacher to visionary leader, emphasising the importance of community, connection, and personal growth. Discover how her personal experiences have shaped her leadership style and learn valuable insights on fostering a sense of belonging in educational environments.',
							mins: 42,
							season: 1,
							episode: 1,
							linkSpotify: 'https://open.spotify.com/episode/4lddjbTRZkjw43qPwWrmZp?si=32a969760ee64f9f',
							linkApple: 'https://podcasts.apple.com/us/podcast/empowering-change-martine-gills-journey-of/id1831912899?i=1000721439657',
							linkOvercast: 'https://overcast.fm/+BQ5LfaYTtc',
							linkPocketCasts: 'https://pocketcasts.com/podcasts/dd723190-59b6-013e-ac0c-0affd8d03709/c05168c0-7c58-42fa-8e8a-641889623243',
						},
						{
							title: "Leading with Kindness: Claire & Jade's Story at Nepean School",
							with: 'Claire Toohey, Jade Leggett',
							shortDescription: 'Tune in to hear how Claire and Jade are making a difference at Nepean School, transforming challenges into opportunities for growth and learning in a unique educational setting.',
							longDescription: 'In this conversation, Adam speaks with Claire Toohey and Jade Leggett from Nepean School about their experiences as educators and the unique culture of their school, which caters to children with physical disabilities. They discuss the importance of restorative practices, effective communication, and the supportive environment that fosters student empowerment and staff collaboration. The conversation highlights the significance of kindness, the role of parents, and the continuous journey of improvement within the school community.',
							mins: 40,
							season: 1,
							episode: 2,
							linkSpotify: 'https://open.spotify.com/episode/65g9l6MhXIQh8p3pq1ShjG?si=94bb7964dc044d20',
							linkApple: 'https://podcasts.apple.com/us/podcast/leading-with-kindness-claire-jades-story-at-nepean-school/id1831912899?i=1000722573786',
							linkOvercast: 'https://overcast.fm/+BQ5LfuU0HA',
							linkPocketCasts: 'https://pocketcasts.com/podcasts/dd723190-59b6-013e-ac0c-0affd8d03709/7ee1c8c9-f448-46aa-90ec-69563867ce51',
						},
						{
							title: 'Navigating the Future of Education',
							with: 'Zoe McKenzie',
							shortDescription: 'Join Zoe McKenzie as she delves into the transformative power of education, sharing insights from her journey from student to shadow assistant minister, and exploring how we can shape a brighter future for the next generation.',
							longDescription: 'In this conversation, Zoe McKenzie reflects on the profound impact of teachers and education on her life, emphasising the importance of values, responsibility, and the role of family. She discusses her journey into politics, driven by a desire to improve education and mental health systems. The conversation explores the intersection of technology and education, the challenges posed by AI, and the necessity of maintaining human connections in an increasingly digital world. Zoe advocates for a balanced approach to education that prepares young people for the future while preserving essential human attributes.',
							mins: 42,
							season: 1,
							episode: 3,
							linkSpotify: 'https://open.spotify.com/episode/2jTTyAcab15yCwDw8Slmd9?si=d6e0c597d8a34006',
							linkApple: 'https://podcasts.apple.com/au/podcast/navigating-the-future-of-education-with-zoe-mckenzie/id1831912899?i=1000721613997',
							linkOvercast: 'https://overcast.fm/+BQ5LdlabdE',
							linkPocketCasts: 'https://pocketcasts.com/podcasts/dd723190-59b6-013e-ac0c-0affd8d03709/ff2b89c5-c401-453e-a5d7-41206f5f72cd',
						},
						{
							title: 'Restorative Practices in Action: A Conversation',
							with: 'Bern Warburton',
							shortDescription: "How Bern Warburton's innovative leadership and commitment to restorative practices transformed Lake Primary School into a thriving educational community, offering valuable insights for educators and leaders alike.",
							longDescription: "In this conversation, Bern Warburton shares her journey as a principal at Lake Primary School, detailing the transformation of the school's culture through restorative practices. She reflects on the impact of caring teachers, the challenges faced during her leadership, and the importance of engaging staff, parents, and students in the process. Bern emphasises the significance of building relationships and fostering a positive school environment, ultimately leading to improved outcomes for students and a sense of pride in the school community.",
							mins: 35,
							season: 1,
							episode: 4,
							linkSpotify: 'https://open.spotify.com/episode/4fzen8evtwzpC8PRgdGxrM?si=88b38caee641486d',
							linkApple: 'https://podcasts.apple.com/us/podcast/restorative-practices-in-action-a-conversation-with/id1831912899?i=1000721590456',
							linkOvercast: 'https://overcast.fm/+BQ5LckNj30',
							linkPocketCasts: 'https://pocketcasts.com/podcasts/dd723190-59b6-013e-ac0c-0affd8d03709/ab746283-831b-4032-b983-fc8b9eead735',
						},
						{
							title: "From Challenges to Change: Darren Brailey's Educational Impact",
							with: 'Darren Brailey',
							shortDescription: "Discover how Darren Brailey's innovative leadership at Morisset High School is transforming education through restorative practices and community engagement, offering valuable insights for educators and leaders alike.",
							longDescription: 'In this conversation, Darren Brailey, principal of Morisset High School, shares his journey of transforming the school culture through restorative practices. He reflects on the influence of a great teacher in his life, the challenges he faced in student engagement, and the importance of consistency and fairness in creating a supportive environment. Brailey emphasises the need for building relationships with parents and the shift from punitive measures to restorative approaches. He discusses the commitment to developing responsible citizens and the ongoing journey of improving school culture.',
							mins: 34,
							season: 1,
							episode: 5,
							linkSpotify: 'https://open.spotify.com/episode/36EDrjKBV6rgdZ2hSHMDqp?si=7552b39ffb794a25',
							linkApple: 'https://podcasts.apple.com/us/podcast/from-challenges-to-change-darren-braileys-educational/id1831912899?i=1000722572251',
							linkOvercast: 'https://overcast.fm/+BQ5LdJt3yo',
							linkPocketCasts: 'https://pocketcasts.com/podcasts/dd723190-59b6-013e-ac0c-0affd8d03709/493497b9-7028-460c-a06c-c72ea43f9b73',
						},
					],
				},
			],
		};
	},
	computed: {
		heroimageurl() {
			return wrapBackgroundImageUrlToCss(heroImage);
		},
		adamimageurl() {
			return wrapBackgroundImageUrlToCss(adamImage);
		},
		groupimageurl() {
			return wrapBackgroundImageUrlToCss(groupImage);
		},
	},
});
</script>

<style scoped lang="scss">
#hero {
	background-image: v-bind(heroimageurl);
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;

	.container {
		min-height: 400px;
	}

	img {
		padding: 20px;
		width: 400px;
	}

	h1 {
		color: white;
		font-size: 40px;
		line-height: 1.1;
		font-family: var(--rs-typography-font-body);

		.title-color-mustard {
			color: rgb(var(--rs-color-brand-mustard));
		}

		.title-color-honey {
			color: rgb(var(--rs-color-brand-honey));
		}

		.title-color-orange {
			color: rgb(var(--rs-color-brand-orange));
		}
	}
}

#listen-now {
	.title {
		font-weight: bold;
		font-size: 25px;
		font-family: var(--rs-typography-font-body);
		letter-spacing: 0.5px;
		text-transform: uppercase;
	}

	.links {
		display: flex;
		justify-content: center;
		gap: 20px;
		margin-top: 20px;

		a img {
			width: 120px;
			height: auto;
		}
	}
}

#intro {
	background-color: rgb(var(--rs-color-brand-tomato));
	color: white;

	.title {
		margin-top: 0;
		color: white;
	}
}

#podcasts {
	background-color: rgb(var(--rs-color-brand-navy));
	padding: 40px 0;

	.title {
		margin-top: 0;
		color: rgb(var(--rs-color-brand-tomato));
		text-align: center;
	}

	.podcasts {
		.podcast {
			margin-bottom: 20px;
			border-radius: 4px;
			background-color: white;
			padding: 20px;

			.details {
				max-width: 900px;

				h6 {
					margin-top: 0;
					margin-bottom: 0;
					font-size: 14px;
				}

				h3 {
					margin-top: 0;
					margin-bottom: 10px;
					font-weight: bold;
				}
			}

			.links {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 10px;

				> div {
					display: flex;
				}

				h6 {
					margin-top: 0;
					margin-bottom: 0;
					font-size: 14px;
				}

				a {
					text-decoration: none;

					&:hover {
						text-decoration: none;
					}

					img {
						width: 50px;
						height: auto;
					}
				}
			}
		}
	}

	@media screen and (width >= 640px) {
		padding: 80px 0;

		.podcasts {
			gap: 40px;

			.podcast {
				display: flex;
				justify-content: space-between;
				margin-bottom: 40px;
				padding: 30px;

				.details {
					padding-right: 80px;
				}
			}
		}
	}
}

.alternatings {
	h3 {
		margin-bottom: 0;
	}

	#adam {
		background-image: v-bind(adamimageurl);
		background-position: center top -100px;
		background-size: cover;
		background-repeat: no-repeat;
		min-height: 400px;
	}

	#group {
		background-image: v-bind(groupimageurl);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		min-height: 400px;
	}
}
</style>
